import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "ru", "th"],
  defaultLocale: "en",
  // Дефолтная локаль (en) — без префикса в URL, остальные — с префиксом (/ru, /th).
  localePrefix: "as-needed",
});

export type Locale = (typeof routing.locales)[number];
